import React from "react";
import type { ChakraProps } from "@chakra-ui/react";
import { Text, Flex } from "@chakra-ui/react";
import {
  CHFlag,
  FRFlag,
  ITFlag,
  JPFlag,
  KRFlag,
  UKFlag,
  USFlag,
  CNFlag,
  IDFlag,
  DEFlag,
  TRFlag,
  ESFlag
} from "components/SvgIcons";

type Props = ChakraProps & {
  countryCode: string;
  madeInLabel: string;
  flagHeight?: string;
};

const mapCodeToCountry = {
  CH: {
    flag: CHFlag
  },
  FR: {
    flag: FRFlag
  },
  IT: {
    flag: ITFlag
  },
  JP: {
    flag: JPFlag
  },
  KR: {
    flag: KRFlag
  },
  GB: {
    flag: UKFlag
  },
  US: {
    flag: USFlag
  },
  CN: {
    flag: CNFlag
  },
  ID: {
    flag: IDFlag
  },
  DE: {
    flag: DEFlag
  },
  TR: {
    flag: TRFlag
  },
  ES: {
    flag: ESFlag
  }
};

export const OriginCountry = ({
  countryCode,
  madeInLabel,
  flagHeight = "1.25rem",
  ...chakraProps
}: Props): JSX.Element | null => {
  const country = mapCodeToCountry[countryCode];
  if (!country) return null;

  return (
    <Flex {...chakraProps} align="center">
      <country.flag width="auto" height={flagHeight} mr={-5} />
      {!!madeInLabel.length && (
        <Text variant="acuminLight" mt={0} mr={-5}>
          {madeInLabel}
        </Text>
      )}
    </Flex>
  );
};
